// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          // Use Vuetify's default colors - these will be overridden dynamically by theme.js
          primary: '#1976D2',    // Vuetify default blue
          secondary: '#424242',  // Vuetify default grey
          accent: '#82B1FF',     // Vuetify default light blue
          error: '#FF5252',      // Vuetify default red
          info: '#2196F3',       // Vuetify default blue
          success: '#4CAF50',    // Vuetify default green
          warning: '#FB8C00',    // Vuetify default orange
        },
      },
    },
  },
})
